module.exports = __webpack_public_path__ + "static/img/bgscimg5moxin2.dd15268.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rppghealth/bgscimg5moxin2.png
// module id = aQeN
// module chunks = 5